import moment from "moment";
import momentTZ from "moment-timezone";
import { TIMEZONE } from "@/Config";
import * as dateFnsLocales from "date-fns/locale";
import { Strings } from "@/resources";
import { formatWithOptions } from "date-fns/fp";

export function getSpecificHumanReadableTime(seconds: number): string {
    const duration = moment.duration(seconds, "seconds");
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();
    let result = "";

    if (hours > 0) {
        result += `${hours} hour${hours > 1 ? "s" : ""} `;
    }
    if (minutes > 0 || hours > 0) {
        // Include minutes if there are hours, even if minutes are 0
        result += `${minutes} minute${minutes !== 1 ? "s" : ""} `;
    }
    result += `${secs} second${secs !== 1 ? "s" : ""}`;

    return result.trim();
}

export function getDateWithFormat(
    date?: string,
    format?: string,
    locale?: string,
): string {
    if (!date) return "";

    const newYorkDate = momentTZ.tz(date, TIMEZONE);
    const userTimeZoneOffset = momentTZ().utcOffset();
    const userDate = newYorkDate.clone().utcOffset(userTimeZoneOffset);

    if (!userDate) return "";

    return formatWithOptions(
        {
            locale: getDateFnsLocale(locale ? locale : Strings.getLanguage()),
        },
        format ? format : "yyyy-MM-dd",
    )(userDate.toDate());
}

export const getDateFnsLocale = (locale: string) => {
    return dateFnsLocales[locale as keyof typeof dateFnsLocales];
};
